module.exports = __webpack_public_path__ + "static/img/mobile.e3b05468.jpg";